import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "../components/Home/HeroSection";
import TeamsSection from "../components/Home/TeamsSection"
import NextMatchesSection from "../components/Home/NextMatchesSection"
import HomeGallerySection from "../components/Home/HomeGallerySection";
import ResultBadge from "../components/Home/ResultBadge"
import ProjectIntroSection from "../components/Home/ProjectIntroSection"

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Liga Deportiva Cantonal Mejía</title>
        <meta
          name="description"
          content="Official platform of the SAAC Basketball Quito 2026 tournament."
        />
      </Helmet>

      <HeroSection />
      <NextMatchesSection />
      <ProjectIntroSection/>
      <HomeGallerySection/>
      <ResultBadge />
    </>
  );
}

export default Home;